import { getAccessToken } from "../Services/authToken";

export interface CancelSlotPanelResponse {
  success: boolean;
  message: string;
}

const hostname = window.location.hostname;

const getBaseUrl = (): string => {
  if (hostname.includes('localhost')) return 'http://localhost:8080';
  if (hostname.includes('dev')) return 'https://candidateinterviewscheduler-dev.pwc.com';
  if (hostname.includes('stg') || hostname.includes('stage')) return 'https://candidateinterviewscheduler-stg.pwc.com';
  return 'https://candidateinterviewscheduler.pwc.com';
};

export async function CancelInterviewSlotPanel(
  slotId: string,
  reason: string,
  slot: any,
  candidateEmail: string
): Promise<CancelSlotPanelResponse> {
  const baseurl = getBaseUrl();
  const token = await getAccessToken();
  if (!token) throw new Error('Authentication required - please log in');

  // Step 1: Cancel the slot
  const res = await fetch(`${baseurl}/api/candidate-dashboard/cancel-slot-panel`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ slotId, cancellation_reason: reason }),
  });

  if (!res.ok) {
    const errorBody = await res.text();
    throw new Error(`Panel cancel failed: ${res.statusText} - ${errorBody}`);
  }

  const result: CancelSlotPanelResponse = await res.json();

  // Step 2: Send cancellation email
  try {
    const panelPairing = slot?.pairing as any;
    const interviewerSlots = [
      { interviewer_email: panelPairing?.interviewer_1_id, interviewer_name: panelPairing?.interviewer_1_name },
      { interviewer_email: panelPairing?.interviewer_2_id, interviewer_name: panelPairing?.interviewer_2_name },
      { interviewer_email: panelPairing?.interviewer_3_id, interviewer_name: panelPairing?.interviewer_3_name },
      { interviewer_email: panelPairing?.interviewer_4_id, interviewer_name: panelPairing?.interviewer_4_name },
      { interviewer_email: panelPairing?.interviewer_5_id, interviewer_name: panelPairing?.interviewer_5_name },
    ].filter(i => i.interviewer_email && i.interviewer_name);

    const reqId = slot?.pairing?.requisition_id || slot?.requisition_id || 'N/A';
    const jobTitle = `${reqId} ${slot?.job_title || 'N/A'}`;

    const payload = {
      email_type: 'panel_interview_cancellation',
      additional_data: {
        candidate_email: candidateEmail,
        candidate_name: panelPairing?.candidate_full_name,
        job_title: jobTitle,
        panel_start_time: new Date(panelPairing?.start_time).toISOString(),
        panel_end_time: new Date(panelPairing?.end_time).toISOString(),
        panel_interview_type: panelPairing?.interview_1_type,
        interviewer_slots: interviewerSlots,
        interview_date: new Date(panelPairing?.start_time).toISOString().split('T')[0],
        cancellation_reason: reason,
        send_to_candidate: true,
        send_to_interviewers: true,
        send_to_recruiter: true,
        recruiter_email: panelPairing?.recruiter_email,
        recruiter_name: panelPairing?.recruiter_name,
        campus_hire: false,
        experienced_hire: true,
      },
    };

    console.log('[CancelInterviewSlotPanel] Email payload for panel cancellation:', JSON.stringify(payload, null, 2));

    const emailRes = await fetch(`${baseurl}/api/communications/emails`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });

    if (!emailRes.ok) {
      console.error('[CancelInterviewSlotPanel] Email failed:', await emailRes.text());
    }
  } catch (emailError) {
    console.error('[CancelInterviewSlotPanel] Email error:', emailError);
  }

  return result;
}